<template>
  <router-view></router-view>
</template>

<style>
* {
    margin: 0 !important;
}
html{
  height: 100% !important;
}
body{
  height: 100% !important;
}
#app {
  height: 100% !important;
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
}

nav {
  padding: 30px;
}

nav a {
  font-weight: bold;
  color: #2c3e50;
}

nav a.router-link-exact-active {
  color: #42b983;
}
</style>
